/* eslint-disable no-unreachable */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react';
import './styles.css';

import ReactLoading from "react-loading";

import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";

import { enqueueSnackbar } from 'notistack';
import { PostFetch } from '../../../../../../services/apiBase';

export  function AddFilesModal({ open, onClose, cprNumber, setIsSended }) {

  const [loadingForm, setLoadingForm] = useState(false);
  const [files, setFiles] = useState([]);

  const handleOnCloseModal = () => {
    setFiles([])
    onClose()
  }

  const handleChangeFile = async (events) => {
    setIsSended(true);
    let uploadFiles = [];

    if (events.length > 1) {
      enqueueSnackbar('Selecione apenas um arquivo para upload', { variant: 'error' });
    } else {
      uploadFiles.push(events[0])
      setFiles(uploadFiles)
    }
    
    // let uploadFiles = [...files];
    // for (const [key, value] of Object.entries(events)) {
    //     uploadFiles.push(value)
    //   }
    //   setFiles(uploadFiles)
      console.log(files)
    }
    
  const handleSubmit = async () => {
    console.log('HANDLING ...')

    setLoadingForm(true);

    if (files.length <= 0) {
      setLoadingForm(false);
      enqueueSnackbar('Selecione uma imagem para upload', { variant: 'error' });
      return
    }

    try {
      const contentType = 'multipart/form-data';

      const url = `/financial/createCprSignedDocuments`;

      for (let i = 0; i < files.length; i++) {
        console.log( files[i] );
        console.log(cprNumber);
      }
      
      const fd = new FormData();
        fd.append('cpr_number', cprNumber);
        for (let i = 0; i < files.length; i++) {
          fd.append('files', files[i]);
        }

        await PostFetch(
          url, 
          fd,
          {
            headers: {
              'Content-Type': contentType
            }
          }
        )

      enqueueSnackbar('Arquivo adicionado com sucesso!', { variant: 'success' });

      // CLEANUP AND CLOSE
      setLoadingForm(false);
      setFiles([]);
      handleOnCloseModal();
      
    } catch (error) {
      console.log('CPR-SIGNED-DOCUMENTS/ADD-FILES-MODAL - ERROR UPLOADING FILE', error);
      setLoadingForm(false);
      return enqueueSnackbar('Erro ao carregar arquivo', { variant: 'error' });
    }
  }

  return (
    <Modal isOpen={open} toggle={handleOnCloseModal} >
      <ModalHeader toggle={handleOnCloseModal}>Adicionar Arquivo</ModalHeader>

      <ModalBody style={{ backgroundColor: "#fff" }} >
        <label
          id="thumbnail"

        >

          <div className="divFile" id="divFile">
            <i className="fa fa-upload" style={{ padding: 5 }} />
            <span>Escolha o arquivo</span>
          </div>

          <input
            type="file"
            multiple
            accept="application/image"
            onChange={event => handleChangeFile(event.target.files)}
          />


        </label>

        <div>
          {files.map((file, index) => {
            return (
              <p key={index}>
                {file.name}
              </p>
            )
          })}
        </div>


        <div className="modal-footer">
          {loadingForm ? (
            <div className="w-100 d-flex justify-content-center align-items-center">
              <ReactLoading type='bubbles' color="#feb049" />
            </div>
          ) : (
            <>
              <Button color="danger" onClick={handleOnCloseModal}>Fechar</Button>
              <Button color="success" type="submit" onClick={() => {handleSubmit()}} >Carregar</Button>
            </>
          )}
        </div>

      </ModalBody>
    </Modal>
  )
}
